import { render, staticRenderFns } from "./form-declaration-departement.vue?vue&type=template&id=509ab9e8"
import script from "./form-declaration-departement.vue?vue&type=script&lang=ts"
export * from "./form-declaration-departement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports